module.exports = __webpack_public_path__ + "img/Angiogenesis-BRCA_10X_Section1.8c6d7612.png";